// extracted by mini-css-extract-plugin
export default {"teacherContainer":"Teacher_teacherContainer__+SfdS","lessonsContainer":"Teacher_lessonsContainer__dbzIy"};